




    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
    import dataProxy from "@/services/data-proxy.service"
    import {GrupeDelovaVozila} from "../services/BackendProxies";
    import {State} from "vuex-class";

@Component({})
export default class GrupaDelovaVozilaEditor extends Vue {
    @State grupeDelova!: {id: string, korektivnoOdrzavanjeId: number, preventivnoOdrzavanjeId: number}[];
    @Prop() value!: string;

    model = '';

    @Watch('value') onValueChange(value) {
        this.model = value;
    }

    @Watch('model') onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {
    }

    @Emit() vrsteOdrzavanja(value) {}

    async created() {
        this.model = this.value;
    }

}
